//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { getPhoneHref } from '../helpers.js'
import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'
import { cardPropertyConfigurableMixin } from './CardPropertyConfigurableMixin.js'

export default {
  name: 'CardPropertyString',
  components: {
    CardPropertyIcon
  },
  mixins: [cardPropertyMixin, cardPropertyConfigurableMixin],
  props: {
    tabProp: {
      type: Object,
      required: true
    },
    object: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      readonlyValue: this.tabProp.componentProps && this.tabProp.componentProps.valuesMap ? this.tabProp.componentProps.valuesMap(this.object[this.tabProp.key]) : null
    }
  },
  computed: {
    copyAvailable: function () {
      const config = this.tabProp || {}
      return config.componentProps && config.componentProps.copy
    },
    isValidIp: function () {
      const ipArray = this.object[this.tabProp.key].split('.')
      if (ipArray.length !== 4) {
        return false
      }
      let valid = true
      ipArray.forEach(el => {
        if (el.length === 0 || el.length > 3 || isNaN(el)) {
          valid = false
        }
      })
      return valid
    },
    rule: function () {
      const value = this.object[this.tabProp.key]
      if (value == null || value === '') {
        return !this.tabProp.required
      }

      if (this.componentProps.formatFio) {
        const normalizedValue = value.replace(/\s+/g, ' ').trim()
        const fioRegex = /^[а-яА-ЯёЁ]+ [а-яА-ЯёЁ]+( [а-яА-ЯёЁ]+)?$/
        return fioRegex.test(normalizedValue) || 'Введите ФИО корректно'
      }

      if (this.componentProps.mask && typeof value === 'string') {
        if (this.componentProps.mask.length !== value.length) {
          return 'Не соответствует формату ' + this.componentProps.mask
        }
      }

      if (this.tabProp._dataType === 'ipAdress') {
        const ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
        return ipRegex.test(value) || 'Введите корректный IP адрес'
      }

      if (this.componentProps.onlyNumbers && isNaN(value)) {
        return 'Только цифры'
      }
      return true
    },
    href: function () {
      return 'http://' + this.object[this.tabProp.key]
    },
    whatsAppHref: function () {
      return getPhoneHref(this.object[this.tabProp.key], 'wa')
    },
    phoneHref: function () {
      return getPhoneHref(this.object[this.tabProp.key])
    }
  },
  mounted: function () {
    if (this.componentProps.immediateValidation) {
      this.$refs.inputField.validate()
    }
  },
  methods: {
    onBlur: function () {
      if (this.componentProps.formatFio) {
        this.object[this.tabProp.key] = this.object[this.tabProp.key].replace(/\s+/g, ' ').trim()
      }
    },
    onInput: function (val) {
      if (this.tabProp._dataType === 'ipAdress') {
        const filteredVal = val.replace(/[^0-9.]/g, '')
        const parts = filteredVal.split('.')
        this.object[this.tabProp.key] = parts.slice(0, 4).join('.')
      }
    },
    onCopy: function (e) {
      const data = [new window.ClipboardItem({ 'text/plain': new Blob([this.object[this.tabProp.key]], { type: 'text/plain' }) })]
      navigator.clipboard.write(data)
    },
    onCallWhatsApp: function (e, go) {
      e.navigate = false
      this.onClickLink(this.whatsAppHref, true)
    },
    onCall: function (e, go) {
      e.navigate = false
      this.onClickLink(this.phoneHref)
    },
    onOpenIp: function (e, go) {
      if (this.isValidIp) {
        this.onClickLink(this.href, true)
      }
    },
    onClickLink: function (href, blank) {
      if (href) {
        const a = document.createElement('a')
        a.href = href
        if (blank) {
          a.target = '_blank'
        }
        a.click()
      }
    }
  }
}
